import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges,
  input,
  output,
  viewChild,
} from '@angular/core';

import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroPlus, heroMinus } from '@ng-icons/heroicons/outline';

export type CounterStyle = 'basket' | 'detail' | 'default' | 'timer';

const COUNTER_STYLE: { [name: string]: { [name: string]: string } } = {
  'ui-badge': {
    default: '',
    detail: 'rounded-[20px] w-full h-full md:w-[192px]',
    basket: 'rounded-[12px] w-[152px] h-full sm:w-[142px]',
    timer: 'rounded-[16px] w-full md:w-[192px] h-[40px]',
  },
};

@Component({
  selector: 'ui-counter',
  imports: [NgIconComponent],
  providers: [
    provideIcons({
      heroPlus,
      heroMinus,
    }),
  ],
  templateUrl: './counter.component.html',
})
export class CounterComponent implements AfterViewInit, OnChanges {
  readonly max = input<number>();
  readonly style = input<CounterStyle>('default');
  readonly description = input<string>();
  @Input() quantity = 1;
  readonly quantityEmitter = output<number>();
  readonly counter = viewChild<ElementRef>('counter');

  ngOnChanges(changes: SimpleChanges) {
    if (changes['max']) {
      if (changes['max'].currentValue < this.quantity) {
        this.quantity = changes['max'].currentValue;
        console.log('Quantity emiiter', this.max());
        this.quantityEmitter.emit(this.quantity);
      }
    }
  }

  ngAfterViewInit() {
    this.addToClassList(COUNTER_STYLE['ui-badge'][this.style()]);
  }

  private addToClassList(className: string) {
    const classes = className.split(' ');
    this.counter()?.nativeElement.classList.add(...classes);
  }

  addNumber() {
    const max = this.max();
    if (max) {
      if (this.quantity < max) {
        this.quantity++;
        this.quantityEmitter.emit(this.quantity);
      }
    } else {
      this.quantity++;
      this.quantityEmitter.emit(this.quantity);
    }
  }

  reduceNumber() {
    this.quantity--;
    this.quantityEmitter.emit(this.quantity);
  }
}
